require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var React = _interopRequireWildcard(require("react"));

var _reactNative = require("react-native-web/dist/index");

var _reactNativeSafeAreaView = _interopRequireDefault(require("react-native-safe-area-view"));

var _Surface = _interopRequireDefault(require("./Surface"));

var _theming = require("../core/theming");

var _jsxFileName = "/Users/trensik/dev/react-native-paper/src/components/Modal.tsx";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2["default"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var DEFAULT_DURATION = 220;

var Modal = function (_React$Component) {
  (0, _inherits2["default"])(Modal, _React$Component);

  function Modal() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2["default"])(this, Modal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(Modal)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      opacity: new _reactNative.Animated.Value(_this.props.visible ? 1 : 0),
      rendered: _this.props.visible
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleBack", function () {
      if (_this.props.dismissable) {
        _this.hideModal();
      }

      return true;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "showModal", function () {
      _reactNative.BackHandler.removeEventListener('hardwareBackPress', _this.handleBack);

      _reactNative.BackHandler.addEventListener('hardwareBackPress', _this.handleBack);

      var opacity = _this.state.opacity;
      var scale = _this.props.theme.animation.scale;

      _reactNative.Animated.timing(opacity, {
        toValue: 1,
        duration: scale * DEFAULT_DURATION,
        easing: _reactNative.Easing.out(_reactNative.Easing.cubic),
        useNativeDriver: true
      }).start();
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "hideModal", function () {
      _reactNative.BackHandler.removeEventListener('hardwareBackPress', _this.handleBack);

      var opacity = _this.state.opacity;
      var scale = _this.props.theme.animation.scale;

      _reactNative.Animated.timing(opacity, {
        toValue: 0,
        duration: scale * DEFAULT_DURATION,
        easing: _reactNative.Easing.out(_reactNative.Easing.cubic),
        useNativeDriver: true
      }).start(function (_ref) {
        var finished = _ref.finished;

        if (!finished) {
          return;
        }

        if (_this.props.visible && _this.props.onDismiss) {
          _this.props.onDismiss();
        }

        if (_this.props.visible) {
          _this.showModal();
        } else {
          _this.setState({
            rendered: false
          });
        }
      });
    });
    return _this;
  }

  (0, _createClass2["default"])(Modal, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.visible !== this.props.visible) {
        if (this.props.visible) {
          this.showModal();
        } else {
          this.hideModal();
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      _reactNative.BackHandler.removeEventListener('hardwareBackPress', this.handleBack);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          rendered = _this$state.rendered,
          opacity = _this$state.opacity;
      if (!rendered) return null;
      var _this$props = this.props,
          children = _this$props.children,
          dismissable = _this$props.dismissable,
          theme = _this$props.theme,
          contentContainerStyle = _this$props.contentContainerStyle;
      var colors = theme.colors;
      return React.createElement(_reactNative.Animated.View, {
        pointerEvents: this.props.visible ? 'auto' : 'none',
        accessibilityViewIsModal: true,
        accessibilityLiveRegion: "polite",
        style: _reactNative.StyleSheet.absoluteFill,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 184
        }
      }, React.createElement(_reactNative.TouchableWithoutFeedback, {
        disabled: !dismissable,
        onPress: dismissable ? this.hideModal : undefined,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 190
        }
      }, React.createElement(_reactNative.Animated.View, {
        style: [styles.backdrop, {
          backgroundColor: colors.backdrop,
          opacity: opacity
        }],
        __source: {
          fileName: _jsxFileName,
          lineNumber: 194
        }
      })), React.createElement(_reactNativeSafeAreaView["default"], {
        style: styles.wrapper,
        pointerEvents: "box-none",
        __source: {
          fileName: _jsxFileName,
          lineNumber: 201
        }
      }, React.createElement(_Surface["default"], {
        style: [{
          opacity: opacity
        }, styles.content, contentContainerStyle],
        __source: {
          fileName: _jsxFileName,
          lineNumber: 202
        }
      }, children)));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.visible && !prevState.rendered) {
        return {
          rendered: true
        };
      }

      return null;
    }
  }]);
  return Modal;
}(React.Component);

(0, _defineProperty2["default"])(Modal, "defaultProps", {
  dismissable: true,
  visible: false
});

var _default = (0, _theming.withTheme)(Modal);

exports["default"] = _default;

var styles = _reactNative.StyleSheet.create({
  backdrop: {
    flex: 1
  },
  wrapper: _objectSpread({}, _reactNative.StyleSheet.absoluteFillObject, {
    justifyContent: 'center'
  }),
  content: {
    backgroundColor: 'transparent',
    justifyContent: 'center'
  }
});